export const SPREADSHEET_TYPE = {
    individual: 1,
    pedigree: 2,
};